import ArrowDown from "src/assets/icons/arrow-down.svg";
import ArrowDownFilled from "src/assets/icons/arrow-down-filled.svg";
import ArrowLeft from "src/assets/icons/arrow-left.svg";
import ArrowRight from "src/assets/icons/arrow-right.svg";
import ArrowUp from "src/assets/icons/arrow-up.svg";
import ArrowUpFilled from "src/assets/icons/arrow-up-filled.svg";
import Info from "src/assets/icons/circle-info.svg";
import Warning from "src/assets/icons/warning.svg";
import LogoutIcon from "src/assets/logout.svg";
import ManagementIcon from "src/assets/management.svg";
import ProfileIcon from "src/assets/profile.svg";

export const Icons = {
    ArrowLeft,
    ArrowRight,
    ArrowDown,
    ArrowUp,
    ArrowDownFilled,
    ArrowUpFilled,
    Info,
    Warning,
    LogoutIcon,
    ManagementIcon,
    ProfileIcon,
} as const;
